import { RISKFIELDS } from "@/api/types/enums";
import RiskFilter from "./risk-management-filter";
import { useEffect, useState } from "react";
import Table, { ColumeDef } from "@/components/shared/Table";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import RiskMatrix from "./risk-matrix";
import Riskform from "./risk-form";
import { Link, useLocation, useParams } from "react-router-dom";
import Increasing from "@/assets/increase.svg";
import Decreasing from "@/assets/decrease.svg";
import Stable from "@/assets/stable.svg";
import { RiskType } from "@/api/mutation/useAddRIskMutation";
import {
  ImpactEnumSchema,
  PlanTypeEnumSchema,
  ProbabilityEnumSchema,
  SeverityEnumSchema,
  StatusEnumSchema,
  TrendEnumSchema,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import useAllRiskQuery from "@/api/query/useAllRisk";
import UserAvatar from "@/components/ui/userAvatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Settings } from "lucide-react";
import TrashCan from "@/assets/svg/TrashCan.svg";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import DuplicateIcon from "@/assets/svg/DuplicateIcon.svg";
import Dialog from "@/components/common/Dialog";
import useRemoveRiskMemberMutation from "@/api/mutation/useRemoveMutation";
import { toast } from "react-toastify";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { errorConfig } from "@/lib/toastError";
import useRiskDuplicateMutation from "@/api/mutation/useRiskDuplicateMutation";
import Loader from "@/components/common/Loader";
import { useUser } from "@/hooks/useUser";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { getSeverityAndColor } from "@/helperFuntions/riskSeverity";
import View from "@/assets/eye-alt.svg";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import crossNew from "@/assets/svg/crossNew.svg";
import NoRisk from "./NoRisk";
import WbsImport from "./wbsImport";
import ExcelJS from "exceljs";
import ExcelIcon from "@/assets/svg/Excel.svg";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import useProjectQuery from "@/api/query/useProjectQuery";
import useRemoveMultiRiskMutation from "@/api/mutation/useRemoveMultiRiskMutation";
function RiskManagement() {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const [risk, setRisk] = useState<RiskType[]>();
  const [dataSource, setDataSource] = useState<RiskType[]>();
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [activeTab, setActiveTab] = useState<number>(1);
  const allRiskQuery = useAllRiskQuery(projectId ?? "");
  const [editRisk, setEditRisk] = useState<RiskType | undefined>();
  const [viewRisk, setViewRisk] = useState<RiskType | undefined>();
  const [removeRisk, setRemoveRisk] = useState<string | undefined>();
  const removeRiskMutation = useRemoveRiskMemberMutation();
  const removeMultiRiskMutation = useRemoveMultiRiskMutation();
  const projectDetailQuery = useProjectDetail(projectId, true);
  const [isShowVideo, setIsShowVideo] = useState(false);
  const [isRemoveMultiple, setIsRemoveMultiple] = useState(false);
  useEffect(() => {
    setDataSource(allRiskQuery.data?.data.data ?? []);
    if (allRiskQuery.data?.data.data && !allRiskQuery.data?.data.data.length) {
      setSelectedRisks([]);
    }
  }, [allRiskQuery.data?.data.data, projectId]);
  const { user } = useUser();
  const userQuary = useCurrentUserQuery();
  useEffect(() => {
    if (
      user &&
      user?.userOrganisation[0]?.organisation?.severityTypes?.length < 3 &&
      userQuary.isFetched
    ) {
      userQuary.refetch();
    }
    if (
      user?.subscription?.planType == PlanTypeEnumSchema.FREE ||
      !user?.subscription
    ) {
      setActiveTab(2);
    }
  }, [user]);

  const impactLevels = Object.keys(ImpactEnumSchema);
  const probabilityLevels = Object.keys(ProbabilityEnumSchema);
  const projects = useProjectQuery();
  const isCollaborator = () => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == projectId
    );
    if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user?.userId &&
          u.projectRole == UserRoleEnumValue.COLLABORATOR
      )
    ) {
      return false;
    } else {
      return true;
    }
  };
  const TabOptions = [
    {
      id: 1,
      tab: t(`risk log`),
    },
    {
      id: 2,
      tab: t(`risk matrix`),
    },
  ];
  const [selectedRisks, setSelectedRisks] = useState<string[]>([]);

  const columeDef: ColumeDef[] = [
    {
      key: "riskId",
      header: t("riskNameId"),
      onHeaderRender: () => {
        if (curruntUserProjectRole !== UserRoleEnumValue.TEAM_MEMBER) {
          return (
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedRisks(risk?.map((r) => r.riskId) ?? []);
                } else {
                  setSelectedRisks([]);
                }
              }}
              checked={risk?.length == selectedRisks?.length}
            />
          );
        } else {
          return <></>;
        }
      },
      onCellRender: (data: RiskType) => {
        return (
          <div className="w-fit">
            <input
              key={data.riskId}
              type="checkbox"
              onChange={() => {
                if (!selectedRisks.includes(data.riskId)) {
                  setSelectedRisks((prev) => [...prev, data.riskId]);
                } else {
                  setSelectedRisks((prev) =>
                    prev.filter((id) => id !== data.riskId)
                  );
                }
              }}
              disabled={!allow(data)}
              checked={selectedRisks.includes(data.riskId)}
            />
          </div>
        );
      },
    },
    {
      header: t("riskNameId"),
      key: "riskNameId",
      className: () => {
        return "!w-36";
      },
      onCellRender: (data: RiskType) => {
        return (
          <>
            <div
              className="text-primary-500 underline truncate w-36 cursor-pointer text-start"
              onClick={() => {
                setIsOpenPopUp(true);
                setEditRisk(data);
              }}
            >
              <TooltipProvider key={data.riskNameId} delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div>{data.riskNameId}</div>
                  </TooltipTrigger>
                  <TooltipContent>{data.riskNameId}</TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          </>
        );
      },
      sorting: true,
    },
    {
      header: t("Risk Title"),
      key: "title",
      sorting: true,
      className: () => {
        return "!w-36";
      },
      onCellRender: (data) => {
        return (
          <div className="w-56">
            <TooltipProvider key={data.riskNameId} delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className=" text-start truncate ">{t(data.title)}</div>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="max-w-64 text-wrap">{data.title}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        );
      },
    },
    {
      header: t("Risk Type"),
      key: "type",
      sorting: true,
      onHeaderRender: () => {
        return <div className="text-nowrap">{t("Risk Type")}</div>;
      },
      onCellRender: (data) => {
        return <>{t(data.type)}</>;
      },
    },
    {
      header: t("impact"),
      key: "impact",
      sorting: true,
      onCellRender: (data) => {
        return <>{t(data.impact)}</>;
      },
    },
    {
      header: t("probability"),
      key: "probability",
      sorting: true,
      onCellRender: (data) => {
        console.log(data);
        
        return <>{t(data.probability)}</>;
      },
    },
    {
      header: t("severity"),
      key: "severity",
      sorting: true,
      className: () => {
        return "[&>*]:h-10";
      },
      onCellRender: (data: RiskType) => {
        function getSeverityColor(severity: keyof typeof SeverityEnumSchema) {
          switch (severity) {
            case SeverityEnumSchema.CRITICAL:
              return "bg-orange-500/90";
            case SeverityEnumSchema.MODERATE:
              return "bg-yellow-500/90";
            case SeverityEnumSchema.VERY_CRITICAL:
              return "bg-red-500/90";
            default:
              return ""; // Or a default color
          }
        }
        const severity = getSeverityAndColor(
          impactLevels.findIndex((t) => t == data.impact),
          probabilityLevels.findIndex((t) => t == data.probability),
          user?.userOrganisation[0].organisation?.severityTypes ?? []
        ).severity as keyof typeof SeverityEnumSchema;
        return (
          <div
            className={`h-full w-32 text-center text-white flex justify-center items-center !rounded-md ${getSeverityColor(
              severity
            )}`}
          >
            {t(severity ?? "")}
          </div>
        );
      },
    },
    {
      header: t("Trend"),
      key: "trend",
      sorting: true,
      className: () => {
        return "[&>*]:h-10 [&>*]:[&>*]:!justify-start";
      },
      onCellRender: (data: RiskType) => {
        const getIcon = () => {
          switch (data.trend) {
            case TrendEnumSchema.INCREASING:
              return (
                <img
                  src={Increasing}
                  alt="Increasing"
                  className=" min-w-14 w-14"
                />
              );
            case TrendEnumSchema.DECREASING:
              return (
                <img
                  src={Decreasing}
                  alt="Decreasing"
                  className=" min-w-14 w-14"
                />
              );
            case TrendEnumSchema.STABLE:
              return (
                <img
                  src={Stable}
                  alt="Stable"
                  className="min-w-20 w-20 mx-auto"
                />
              );
          }
        };
        return (
          <div
            className={`h-full  w-full ml-5 p-2 text-white flex justify-center items-center !rounded-md `}
          >
            {getIcon()}
          </div>
        );
      },
    },
    {
      header: t("owner"),
      key: "owner",
      onCellRender(data: RiskType) {
        return (
          <div
            className={`h-full  w-full p-2 text-white flex justify-center items-center !rounded-md `}
          >
            {data.responsibleUser && <UserAvatar user={data.responsibleUser} />}
          </div>
        );
      },
    },
    {
      header: t("Consequences"),
      key: "consequences",
      onCellRender: (data) => {
        return (
          <>
            {data.consequences?.length > 50
              ? data.consequences?.slice(0, 50) + "..."
              : data.consequences}
          </>
        );
      },
    },
    {
      header: t("Preventive Measures"),
      key: "preventiveMeasure",
      onCellRender: (data) => {
        return (
          <>
            {data.preventiveMeasure?.length > 50
              ? data.preventiveMeasure?.slice(0, 50) + "..."
              : data.preventiveMeasure}
          </>
        );
      },
    },
    {
      header: t("Corrective Measures"),
      key: "correctiveMeasure",
      onCellRender: (data) => {
        return (
          <>
            {data.correctiveMeasure?.length > 50
              ? data.correctiveMeasure?.slice(0, 50) + "..."
              : data.correctiveMeasure}
          </>
        );
      },
    },
    {
      header: t("status"),
      key: "status",
      sorting: true,
      onCellRender: (data) => {
        return <>{t(data.status)}</>;
      },
    },
    ...(isCollaborator()
      ? [
          {
            key: "Action",
            header: t("actions"),
            onCellRender: (item: RiskType) => (
              <>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <div
                      className={`cursor-pointer  px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex`}
                    >
                      <img src={NewEditIcon} className="mr-2 h-4 w-4" />
                    </div>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="w-fit flex flex-col gap-1">
                    {allow(item, "View") && (
                      <DropdownMenuItem
                        onClick={() => {
                          setViewRisk(item);
                          setIsOpenPopUp(true);
                        }}
                      >
                        <img src={View} className="h-4 w-4 mr-2" />
                        <span className="p-0 font-normal h-auto ">
                          {t("view")}
                        </span>
                      </DropdownMenuItem>
                    )}
                    {allow(item) && (
                      <DropdownMenuItem
                        onClick={() => {
                          createDuplicateRisk(item.riskId);
                        }}
                      >
                        <img src={DuplicateIcon} className="h-4 w-4 mr-2" />
                        <span className="p-0 font-normal h-auto">
                          {t("duplicate_risk")}
                        </span>
                      </DropdownMenuItem>
                    )}
                    {allow(item, "Edit") && (
                      <DropdownMenuItem
                        onClick={() => {
                          setEditRisk(item);
                          setIsOpenPopUp(true);
                        }}
                      >
                        <Settings className="mr-2 h-4 w-4 " />
                        <span className="p-0 font-normal h-auto">
                          {t("edit")}
                        </span>
                      </DropdownMenuItem>
                    )}
                    {allow(item) && (
                      <DropdownMenuItem
                        onClick={() => setRemoveRisk(item.riskId)}
                      >
                        <img src={TrashCan} className="h-4 w-4 mr-2" />
                        <span className="p-0 font-normal h-auto text-red-500">
                          {t("delete")}
                        </span>
                      </DropdownMenuItem>
                    )}
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            ),
          },
        ]
      : []),
  ];
  const removeRiskFn = () => {
    removeRiskMutation.mutate(removeRisk ?? "", {
      onSettled(data) {
        toast.success(errorKeyFormate(data?.data.message ?? ""));
        allRiskQuery.refetch();
        setRemoveRisk(undefined);
      },
      onError(error) {
        toast.error(errorKeyFormate(error.message ?? ""), errorConfig);
      },
    });
  };
  const removeMultiRiskFn = () => {
    removeMultiRiskMutation.mutate(selectedRisks ?? "", {
      onSettled(data) {
        toast.success(errorKeyFormate(data?.data.message ?? ""));
        allRiskQuery.refetch();
        setSelectedRisks([]);
        setIsRemoveMultiple(false);
      },
      onError(error) {
        toast.error(errorKeyFormate(error.message ?? ""), errorConfig);
      },
    });
  };

  const riskDuplicateMutation = useRiskDuplicateMutation();
  const createDuplicateRisk = (data: string) => {
    riskDuplicateMutation.mutate(data, {
      onSuccess(data) {
        toast.success(data.data.message);
        allRiskQuery.refetch();
      },
      onError(error) {
        toast.error(errorKeyFormate(error.response?.data.message + ""));
      },
    });
  };

  const open = (data: RiskType) => {
    setEditRisk(data);
    setIsOpenPopUp(true);
  };
  const location = useLocation();
  useEffect(() => {
    if (location.state) {
      open(location.state);
    }
  }, [location.state]);

  const [filterd, setFilterd] = useState(false);
  useEffect(() => {
    if (dataSource?.length && !risk?.length) {
      setFilterd(true);
    } else {
      setFilterd(false);
    }
  }, [dataSource, risk]);

  const curruntUserProjectRole =
    projectDetailQuery.data?.data.data.assignedUsers.find(
      (item) => item.user.userId == user?.userId
    )?.projectRole;
  const allow = (risk: RiskType, action?: "Edit" | "View" | undefined) => {
    const riskResponsibleUser = risk.responsibleUser;
    if (
      curruntUserProjectRole !== UserRoleEnumValue.TEAM_MEMBER &&
      action == "View"
    ) {
      return false;
    } else if (
      user?.userOrganisation[0].role == UserRoleEnumValue.ADMINISTRATOR
    ) {
      return true;
    } else if (curruntUserProjectRole == UserRoleEnumValue.PROJECT_MANAGER) {
      return true;
    } else if (
      (riskResponsibleUser?.userId == user?.userId &&
        (curruntUserProjectRole == UserRoleEnumValue.TEAM_MEMBER ||
          !curruntUserProjectRole) &&
        action == "Edit") ||
      action == "View"
    ) {
      return true;
    } else {
      return false;
    }
  };
  const [allowCreate, setAllowCreate] = useState(false);
  useEffect(() => {
    const role = projectDetailQuery.data?.data.data.assignedUsers.find(
      (item) => item.user.userId == user?.userId
    )?.projectRole;
    setAllowCreate(role !== UserRoleEnumValue.TEAM_MEMBER);
  }, [projectDetailQuery.data?.data.data, projectId, user]);

  const downloadExcel = async (data: RiskType[]) => {
    const projectName =
      projectDetailQuery.data?.data.data.projectName || "Project";

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Risks");

    // Define column headers
    worksheet.columns = [
      { header: "ID", key: "riskNameId", width: 10 },
      { header: "Titre du risque", key: "title", width: 30 },
      { header: "Type de risque", key: "type", width: 20 },
      { header: "Description", key: "description", width: 40 },
      { header: "Impact", key: "impact", width: 15 },
      { header: "Probabilite", key: "probability", width: 20 }, // no accent
      { header: "Consequence si avere", key: "consequences", width: 35 }, // note spelling
      { header: "Statut", key: "status", width: 15 },
      { header: "Tendance", key: "trend", width: 20 },
      { header: "Responsable(email)", key: "owner", width: 25 }, // match import
      { header: "Actions preventives", key: "preventiveMeasure", width: 40 },
      { header: "Actions correctives", key: "correctiveMeasure", width: 40 },
    ];

    data.forEach((risk) => {
      worksheet.addRow({
        riskNameId: risk.riskNameId,
        title: risk.title,
        type: risk.type,
        description: risk.description ?? "",
        impact: t(risk.impact, { lng: "fr" }),
        probability: t(risk.probability, { lng: "fr" }),
        consequences: risk.consequences ?? "",
        status: t(risk.status, { lng: "fr" }),
        trend: t(risk.trend, { lng: "fr" }),
        owner: risk.responsibleUser?.email ?? "",
        preventiveMeasure: risk.preventiveMeasure ?? "",
        correctiveMeasure: risk.correctiveMeasure ?? "",
      });
    });

    // Add dropdowns (example for impact, probability, trend, status)
    const addDropdown = (
      col: string,
      options: string[],
      startRow = 2,
      endRow = data.length + 1
    ) => {
      for (let i = startRow; i <= endRow; i++) {
        worksheet.getCell(`${col}${i}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`"${options.join(",")}"`],
        };
      }
    };

    addDropdown(
      "C",
      user?.userOrganisation[0].riskType ?? ["Humain", "Technique", "Légal"],
      2
    );
    addDropdown("E", ["Mineur", "Majeur", "Grave", "Catastrophique"], 2);
    addDropdown(
      "F",
      ["Improbable", "Peu probable", "Probable", "Très probable"],
      2
    );
    addDropdown("I", ["Stable", "En augmentation", "En diminution"], 2);
    addDropdown("H", ["Actif", "Fermé"], 2);

    // Style header
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9EAD3" }, // light green
      };
      cell.border = {
        bottom: { style: "thin" },
      };
    });

    // Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${projectName}_risks.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="h-full p-3 px-6 relative overflow-auto">
      {(allRiskQuery.isFetching || allRiskQuery.isRefetching) && (
        <Loader className="absolute top-0 left-0 h-full w-full z-10 bg-white" />
      )}
      <div className="flex justify-between mb-3 ">
        <div className="flex items-center gap-2">
          {selectedRisks?.length > 0 && (
            <>
              <Button
                variant={"destructive"}
                onClick={() => {
                  setIsRemoveMultiple(true);
                }}
              >
                {t("remove")}
              </Button>
            </>
          )}
          <RiskFilter
            fieldToShow={[
              RISKFIELDS.TITLE,
              RISKFIELDS.TYPE,
              RISKFIELDS.IMPACT,
              RISKFIELDS.SEVERITY,
              RISKFIELDS.STATUS,
              RISKFIELDS.RESPONSIBLE,
              RISKFIELDS.TREND,
              RISKFIELDS.PROBABILITY,
            ]}
            data={dataSource}
            small={selectedRisks.length>0}
            filteredData={(data: RiskType[] | undefined) => {
              setRisk(data ?? []);
            }}
          />
          <WbsImport
            projectId={projectId ?? ""}
            refetch={allRiskQuery.refetch}
            iconOnly
          />
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild>
                <li className="flex-1 list-none">
                  <Button
                    variant={"none"}
                    className=" !p-2"
                    onClick={() =>
                      downloadExcel(allRiskQuery.data?.data.data ?? [])
                    }
                  >
                    <img src={ExcelIcon} className="w-4 min-w-4 mr-0.5" />
                    <img src={DownLoadIcon} className="w-2 min-w-2 mt-2" />
                  </Button>
                </li>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm">{t("export your risk")}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>

        <div className="flex items-center gap-4">
          <Link
            to={"/risk/scales"}
            className="underline text-sm underline-offset-4"
          >
            {t("Impact and Probability Scales")}
          </Link>

          {allowCreate && isCollaborator() && (
            <Button
              variant={"primary"}
              onClick={() => setIsOpenPopUp(true)}
              className=" "
            >
              {t("Add_Risk")}
            </Button>
          )}
        </div>
      </div>

      <div className="flex gap-10 items-center justify-between text-gray-450 text-base  font-bold my-3.5  border-b">
        {TabOptions &&
          TabOptions.map((item, index) => (
            <div
              key={index}
              className={`cursor-pointer ${
                activeTab === item.id &&
                "text-primary-500 underline underline-offset-8 "
              }`}
              onClick={() => {
                if (activeTab == 1) {
                  setActiveTab(item.id);
                } else {
                  setActiveTab(item.id);
                }
              }}
            >
              {item.tab}
            </div>
          ))}
        <Button
          variant={"link"}
          onClick={() => setIsShowVideo(true)}
          className="text-primary-500 underline underline-offset-2 text-sm ml-auto h-fit !p-0  "
        >
          {t("Check the video")}
        </Button>
      </div>
      {activeTab === 1 && (
        <div className="h-[88%]">
          {risk?.length ? (
            <Table
              columnDef={columeDef}
              onRowClassName={(data: RiskType) => {
                return data.status === StatusEnumSchema.CLOSE
                  ? "bg-gray-50"
                  : "";
              }}
              hederClassName={`${!risk?.length ? "hidden" : ""}`}
              data={risk ?? []}
              className="w-full !px-0 !h-full"
              hidePagination={Boolean(!risk?.length)}
              hideHeaders={Boolean(!risk?.length)}
            ></Table>
          ) : (
            <NoRisk
              projectId={projectId ?? ""}
              refetch={() => allRiskQuery.refetch()}
              filtered={filterd}
              noShowImage={false}
            />
          )}
        </div>
      )}
      {activeTab === 2 && (
        <div className=" ">
          <RiskMatrix
            data={risk ?? []}
            open={open}
            projectId={projectId ?? ""}
          />
        </div>
      )}
      {(isOpenPopUp || editRisk?.riskNameId || viewRisk) && (
        <Riskform
          isOpen={isOpenPopUp}
          setClose={(data, type) => {
            setIsOpenPopUp(data);
            if (type == "update") {
              allRiskQuery.refetch();
            }
            setEditRisk(undefined);
            setViewRisk(undefined);
          }}
          riskId={editRisk?.riskId ?? ""}
          projectId={projectId ?? ""}
          riskData={editRisk ?? viewRisk}
          viewOnly={viewRisk?.riskId ? true : false}
        />
      )}
      <Dialog
        isOpen={Boolean(removeRisk)}
        onClose={() => setRemoveRisk(undefined)}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeRiskMutation.isPending}
              disabled={removeRiskMutation.isPending}
              onClick={() => setRemoveRisk(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              onClick={removeRiskFn}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(isRemoveMultiple)}
        onClose={() => setIsRemoveMultiple(false)}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeRiskMutation.isPending}
              disabled={removeRiskMutation.isPending}
              onClick={() => setIsRemoveMultiple(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              onClick={removeMultiRiskFn}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => {}}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30"
            onClick={() => setIsShowVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1054493760?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
    </div>
  );
}

export default RiskManagement;
